import { render } from "./DisplayInvoice.vue?vue&type=template&id=2017f61d&scoped=true"
import script from "./DisplayInvoice.vue?vue&type=script&lang=js"
export * from "./DisplayInvoice.vue?vue&type=script&lang=js"

import "./DisplayInvoice.vue?vue&type=style&index=0&id=2017f61d&lang=less&scoped=true"
import "./DisplayInvoice.vue?vue&type=style&index=1&id=2017f61d&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/collections/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2017f61d"]])

export default __exports__